var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthnaOffBgMd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1234,
    height: 485,
    viewBox: "0 0 1234 485",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 24C0 10.7452 10.7452 0 24 0H1210C1223.25 0 1234 10.7452 1234 24V317C1234 330.255 1223.25 341 1210 341H258C230.386 341 208 363.386 208 391V407C208 426.33 192.33 442 173 442V442C153.67 442 138 426.33 138 407V375C138 356.222 122.778 341 104 341V341C85.2223 341 70 356.222 70 375V450C70 469.33 54.33 485 35 485V485C15.67 485 0 469.33 0 450V317V189V24Z",
    fill: "url(#paint0_linear_13_312)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13_312",
    x1: 26.0704,
    y1: 198.391,
    x2: 1309.1,
    y2: 947.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.319327,
    stopColor: "#F84CDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904445,
    stopColor: "#FFE600"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthnaOffBgMd);
export default __webpack_public_path__ + "static/media/ethna_off_bg_md.66fbfe991a07d79d27e9a6cfd33e086e.svg";
export { ForwardRef as ReactComponent };